(function () {
  'use strict';

  angular
  .module('neo.home.refereeNewInvoice.invoiceslist')
  .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('home.invoiceslist', {
      url: '/referee-new-invoice/invoiceslist',
     
          templateUrl: 'home/referee-new-invoice/invoices-list/invoices-list.tpl.html',
          controller: 'invoiceslist',
          controllerAs: 'vm',
        resolve:{
          townHalls: function (Ajuntaments) {
            return Ajuntaments.query().$promise;
          }
        }
       
    });
  }
}());


